import { defineStore } from 'pinia';

export interface UTMState {
  source: string;
  medium: string | null;
  campaign: string | null;
  term: string | null;
  content: string | null;
  name: string | null;
  tencentXj: string | null;
  qzGdt: string | null;
  gdtVid: string | null;
}

export const useUTMStore = defineStore('utm', {
  state: (): UTMState => ({
    source: 'yrxd_web', // 该参数同时作为流量来源追踪及渠道标识符
    medium: '',
    campaign: '',
    term: '',
    content: '',
    name: '', // 渠道来源对应的中文名称
    tencentXj: '', // 是否使用腾讯蹊径
    qzGdt: '', // 腾讯蹊径GDT流量标识
    gdtVid: '', // 腾讯蹊径微信流量标识
  }),
  actions: {
    update(payload: Partial<UTMState>) {
      this.source = payload.source ?? this.source;
      this.medium = payload.medium ?? this.medium;
      this.campaign = payload.campaign ?? this.campaign;
      this.content = payload.content ?? this.content;
      this.term = payload.term ?? this.term;
      this.name = payload.name ?? this.name;
      this.tencentXj = payload.tencentXj ?? this.tencentXj;
      this.qzGdt = payload.qzGdt ?? this.qzGdt;
      this.gdtVid = payload.gdtVid ?? this.gdtVid;
    },
  },
});
